import { resolveComponent as d, createElementBlock as e, openBlock as t, createVNode as c, createElementVNode as s, normalizeClass as i, createCommentVNode as n, renderSlot as r } from "vue";
/* empty css                 */
import m from "../../_virtual/_plugin-vue_export-helper.js";
import l from "../../utils/mixins/screen/screen.vue.js";
import p from "../../atoms/divider/divider.vue.js";
const _ = {
  name: "DsPageFooter",
  components: { DsDivider: p },
  mixins: [l],
  provide() {
    return {
      trackingData: { "component-name": this.$options.name }
    };
  }
}, g = { class: "ds-page-footer ds-background-color-white" }, f = { class: "ds-grid ds-page-footer__bottom" }, u = { class: "ds-grid__col ds-grid__col--12 ds-page-footer__bottom-row" }, v = {
  key: 0,
  class: "ds-margin-bottom-48 ds-md-margin-bottom-0 ds-align-items-center"
};
function h(o, $, b, D, k, w) {
  const a = d("DsDivider");
  return t(), e("section", g, [
    c(a, { theme: "light" }),
    s("div", {
      class: i(["ds-container ds-padding-top-48 ds-md-padding-top-96 ds-background-color-white ds-page-footer__container", { "ds-page-footer__container--switcher": !!o.$slots.localeSwitcher }])
    }, [
      o.$slots.primaryNavigation ? (t(), e("div", {
        key: 0,
        class: i(["ds-margin-bottom-48 ds-md-margin-bottom-96 ds-lg-margin-bottom-144", { "ds-align-items-center": !o.$slots.primaryNavigation }])
      }, [
        r(o.$slots, "primaryNavigation", {}, void 0, !0)
      ], 2)) : n("", !0),
      s("div", f, [
        s("div", u, [
          r(o.$slots, "secondaryNavigation", {}, void 0, !0),
          o.$slots.localeSwitcher ? (t(), e("div", v, [
            r(o.$slots, "localeSwitcher", {}, void 0, !0)
          ])) : n("", !0)
        ])
      ])
    ], 2)
  ]);
}
const B = /* @__PURE__ */ m(_, [["render", h], ["__scopeId", "data-v-837c6bdb"]]);
export {
  B as default
};
